import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  padding: 4px;
`;

export default Container;
